import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Button, Grid, Typography, units } from '@hbf/dsl';
import { VpLargeComponentData } from './types';

const useStyles = makeStyles()(theme => ({
  title: {
    marginBottom: units.rem(1),
    [theme.breakpoints.up('md')]: {
      marginBottom: units.rem(1.5),
    },
  },
  descriptionContainer: {
    [theme.breakpoints.down('md')]: {
      marginBottom: units.rem(1.5),
    },
  },
  container: {
    marginBottom: units.rem(2.5),
  },
}));

export interface Props {
  valueProposition: VpLargeComponentData;
}

export const VpLarge: React.FC<Props> = ({ valueProposition }) => {
  const { classes } = useStyles();
  return (
    <div>
      <Typography.H1 className={classes.title} component="h3">
        {valueProposition.title}
      </Typography.H1>
      <Grid
        container
        justifyContent="space-between"
        className={classes.container}
      >
        <Grid item xs={12} md={6} className={classes.descriptionContainer}>
          <Typography.Paragraph>
            {valueProposition.description}
          </Typography.Paragraph>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography.ParagraphTitle>
            {valueProposition.sideBarTitle}
          </Typography.ParagraphTitle>
          <Typography.Paragraph>
            {valueProposition.sideBarText}
          </Typography.Paragraph>
        </Grid>
      </Grid>
      {valueProposition.ctaUrl && (
        <Button
          href={valueProposition.ctaUrl}
          color="primary"
          variant="contained"
        >
          {valueProposition.ctaTitle}
        </Button>
      )}
    </div>
  );
};
